export enum Permissions {
  BrokersCreate = `brokers:create`,
  BrokersRead = `brokers:read`,
  BrokersUpdate = `brokers:update`,
  CarriersCreate = `carriers:create`,
  CarriersDelete = `carriers:delete`,
  CarriersRead = `carriers:read`,
  CarriersUpdate = `carriers:update`,
  CustomersCreate = `customers:create`,
  CustomersRead = `customers:read`,
  CustomersUpdate = `customers:update`,
  FleetsCreate = `fleets:create`,
  FleetsRead = `fleets:read`,
  FleetsUpdate = `fleets:update`,
  InvoicesIssue = `invoices:issue`,
  InvoicesRead = `invoices:read`,
  InvoicesSettle = `invoices:settle`,
  PoliciesAdjust = `policies:adjust`,
  PoliciesBill = `policies:bill`,
  PoliciesBind = `policies:bind`,
  PoliciesCancel = `policies:cancel`,
  PoliciesConfigure = `policies:configure`,
  PoliciesLapse = `policies:lapse`,
  PoliciesRead = `policies:read`,
  PoliciesRecalculate = `policies:recalculate`,
  PoliciesReinstate = `policies:reinstate`,
  PoliciesUpdateBilling = `policies:update:billing`,
  PoliciesUpdateDistributors = `policies:update:distributors`,
  PoliciesUpdateInsured = `policies:update:insured`,
  PoliciesUpdatePaymentMechanism = `policies:update:payment-mechanism`,
  PoliciesVoid = `policies:void`,
  PricingRun = `pricing:run`,
  QuotesChange = `quotes:change`,
  QuotesCreate = `quotes:create`,
  QuotesIssue = `quotes:issue`,
  QuotesPrice = `quotes:price`,
  QuotesRead = `quotes:read`,
  QuotesRefer = `quotes:refer`,
  QuotesReject = `quotes:reject`,
  QuotesVoid = `quotes:void`,
  ReferralsRead = `referrals:read`,
  TspsCreate = `tsps:create`,
  TspsDelete = `tsps:delete`,
  TspsRead = `tsps:read`,
  TspsUpdate = `tsps:update`,
  UsersCreate = `users:create`,
  UsersRead = `users:read`,
  UsersUpdate = `users:update`,
}
